<template>
  <a
    class="share-facebook-button"
    href=""
    target="_blank"
    @click.prevent="facebookShare"
  >
    SHARE ON FACEBOOK
  </a>
</template>
<script>
export default {
  name: 'ShareFacebook',
  data() {
    return {
      url: null
    };
  },
  mounted() {
    this.url = window.location.href;
  },
  methods: {
    facebookShare() {
      window.open(
        'https://www.facebook.com/sharer/sharer.php?u=' + this.url,
        'facebook-share-dialog',
        'width=800,height=600'
      );
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/components/share-facebook-button.scss';
</style>
